import { Input } from "reactstrap";

const NormalInput = ({
  options,
  value,
  setValue,
  placeholder,
  className,
  type,
  error,
}) => {
  return (
    <Input
      className={`normal-input ${className} ${error ? "border-danger" : ""}`}
      placeholder={placeholder}
      value={value}
      type={type}
      onChange={(e) => setValue(e?.target?.value)}
    >
      {options
        ? options?.map((item, key) => (
            <option selected={value === item} key={key}>
              {item}
            </option>
          ))
        : null}
    </Input>
  );
};

export default NormalInput;
